// removed by extract-text-webpack-plugin
module.exports = {"Tooltip":"_3d-gR","TooltipError":"_2NUIl","ShowTooltipError":"_1ROML"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TooltipError/TooltipError.scss
// module id = 453
// module chunks = 0